import * as React from 'react';
//import * as Select from 'react-select';
import { BaseComponent } from './BaseComponent';
import { Trad } from '../components/';
import * as Dati from '../Dati';
import * as Glob from '../Globale';

interface ICampoTabellaJSONProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON; //JSON mandanti
}

export class CampoTabellaJSON extends BaseComponent<ICampoTabellaJSONProps, {}> {

    private _Dati: any[] = [];
    private _DatiFiltrati: any[] = [];
    private _TR: any[] = [];
    private _ORDER: string[] = [];
    private _FILTER: string[] = [];
    private _TH: any[] = [];
    private _CSS: string = "";
    private _pagina: number = 0;
    private _righe: number = 10;

    constructor(props: any) {
        super(props);
        this.OnCambiaNumeroDiRighe = this.OnCambiaNumeroDiRighe.bind(this);
    }

    private Inizializza(props: ICampoTabellaJSONProps) {
        this._CSS = this.props.CSS != undefined ? this.props.CSS : "";
        this._Dati = [];
        this._DatiFiltrati = [];
        if (this.props.Value != null)
            this._Dati = JSON.parse(this.props.Value);
        this.RecuperaColonne();
    }

    private RecuperaColonne() {
        this._TH = [];
        if (this._Dati.length > 0) {
            const objectKeys = Object.keys(this._Dati[0]) as Array<keyof string>;
            for (let key of objectKeys) {
                this._TH.push(key);
                if (this._ORDER.length < this._TH.length) {
                    this._ORDER.push("");
                    this._FILTER.push("");
                }
            }
        }
    }

    private OnChangeFiltro(e: React.FormEvent<any>, i: number): void {
        this._FILTER[i] = e.currentTarget.value;
        this.forceUpdate();
    }

    private FiltraDati() {
        this._DatiFiltrati = this._Dati;
        for (let f: number = 0; f < this._FILTER.length; f++) {
            if (this._FILTER[f] != "") {
                this._DatiFiltrati = this._DatiFiltrati.filter(x => x[this._TH[f]].includes(this._FILTER[f]))
            }
        }
        //this.OrdinaDati();
    }

    private OrdinaDati() {
        this._DatiFiltrati = this._DatiFiltrati.sort((x, y) => {
            let result: number = 1;
            for (let i: number = 0; i < this._ORDER.length; i++) {
                if (this._ORDER[i] == "ASC" && result > 0) {
                    if (x[this._TH[i]] > y[this._TH[i]]) {
                        result = result * 1;
                    } else {
                        result = result * -1;
                    }
                } else if (this._ORDER[i] == "DESC" && result > 0) {
                    if (x[this._TH[i]] < y[this._TH[i]]) {
                        result = result * 1;
                    } else {
                        result = result * -11;
                    }
                }
            }
            return result;
        });
    }

    private OnOrdinamento(e: React.FormEvent<any>, index: number): void {
        if (this._ORDER[index] == "ASC")
            this._ORDER[index] = "DESC";
        else
            this._ORDER[index] = "ASC";

        this.forceUpdate();
    }

    private EsponiIntestazione(): any {
        let trIntestazione: any[] = [];
        for (let i: number = 0; i < this._TH.length; i++) {
            trIntestazione.push(<th key={"TH_" + i} onClick={(e) => this.OnOrdinamento(e, i)}><span>{this._TH[i].toUpperCase()}</span></th>);
        }
        return <tr>{trIntestazione}</tr>;
    }

    private EsponiFiltri(): any {
        let trIntestazione: any[] = [];
        for (let i: number = 0; i < this._TH.length; i++) {
            trIntestazione.push(<th key={"TH_" + i} ><input name={this._TH[i].toUpperCase()} id={this._TH[i].toUpperCase()} onChange={(e) => this.OnChangeFiltro(e, i)} value={this._FILTER[i]} /></th>);
        }
        return <tr>{trIntestazione}</tr>;
    }

    private EsponiDati(): any {
        let trDati: any[] = [];
        let tdDati: any[] = [];
        for (let r: number = (this._pagina * this._righe); ((r < this._DatiFiltrati.length) && (r < ((this._pagina * this._righe) + this._righe))); r++) {
            tdDati = [];
            for (let c: number = 0; c < this._TH.length; c++) {
                tdDati.push(<td key={"TD" + (r * 10 + c)}><span>{this._DatiFiltrati[r][this._TH[c]]}</span></td>);
            }
            trDati.push(<tr key={"TR" + (r * 10)}>{tdDati}</tr>);
        }
        return trDati;
    }

    private PaginaSelezionataCSS(p: number): string {
        if (p == this._pagina) {
            return "paginate_button page-item active";
        } else {
            return "paginate_button page-item";
        }
    }

    private OnIncrementaPagina(e: React.FormEvent<any>, incremento: number) {
        incremento = incremento + this._pagina;

        if (incremento > ~~(this._DatiFiltrati.length / this._righe))
            incremento = ~~(this._DatiFiltrati.length / this._righe);

        if (incremento < 0)
            incremento = 0;

        this._pagina = incremento;

        this.forceUpdate();
    }

    private OnCambiaNumeroDiRighe(e: React.FormEvent<any>): void {
        this._righe = e.currentTarget.value;
        this._pagina = 0;
        this.forceUpdate();
    }

    private EsponiComandi(): any {
        let numeriPagine: any[] = [];
        for (let p: number = 0; p < this._DatiFiltrati.length / this._righe; p++) {
            numeriPagine.push(<li key={"P" + p} className={this.PaginaSelezionataCSS(p)}>
                <a onClick={(e) => { e.preventDefault(); this.OnCambiaPagina(e, p); }} className="page-link" data-page={p} title={p.toString()}>{p + 1}</a>
            </li>)
        }
        return <div className="row">
            <div className={Glob.DimensioneCSS(2)}>
                <div className="dataTables_info" id="kt_table_1_info" role="status" aria-live="polite">
                    {Trad.TradParam("Visualizza da {1-S} a {2-S} di {3-S} record", [(this._pagina * this._righe) + 1, (this._pagina + 1) * this._righe, this._DatiFiltrati.length])}
                </div>
            </div>
            <div className={Glob.DimensioneCSS(10) + " dataTables_pager"}>
                <div className="row">
                    <div className={Glob.DimensioneCSS(1) + " dataTables_length"}>
                        <label>Display</label>
                    </div>
                    <div className={Glob.DimensioneCSS(1) + " dataTables_length"}>
                        <select name="kt_table_1_length" aria-controls="kt_table_1" className="custom-select custom-select-sm form-control form-control-sm" onChange={this.OnCambiaNumeroDiRighe} defaultValue={this._righe.toString()}>
                            <option value="10">10</option>
                            <option value="25">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div className={Glob.DimensioneCSS(10) + " dataTables_paginate paging_simple_numbers"} id="kt_table_1_paginate">
                        <ul className="pagination">
                            <li className="paginate_button page-item previous">
                                <a onClick={(e) => { e.preventDefault(); this.OnCambiaPagina(e, 0); }} title="First" className="page-link" data-page="1">
                                    <i className="la la-angle-double-left"></i>
                                </a>
                            </li>
                            <li className="paginate_button page-item previous">
                                <a onClick={(e) => { e.preventDefault(); this.OnIncrementaPagina(e, -1); }} title="Previous" className="page-link" data-page="3">
                                    <i className="la la-angle-left"></i>
                                </a>
                            </li>
                            {numeriPagine}
                            <li className="paginate_button page-item next">
                                <a onClick={(e) => { e.preventDefault(); this.OnIncrementaPagina(e, 1); }} title="Next" className="page-link" data-page="5">
                                    <i className="la la-angle-right"></i>
                                </a>
                            </li>
                            <li className="paginate_button page-item next">
                                <a onClick={(e) => { e.preventDefault(); this.OnCambiaPagina(e, ~~(this._DatiFiltrati.length / this._righe)); }} title="Last" className="page-link" data-page="10">
                                    <i className="la la-angle-double-right"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>;
    }

    private OnCambiaPagina(e: React.FormEvent<any>, index: number): void {
        this._pagina = index;
        this.forceUpdate();
    }

    public render() {
        this.Inizializza(this.props);
        this.FiltraDati();
        return <div id={this.props.Id} className={this._CSS + " kt_datatable kt-datatable kt-datatable--default kt-datatable--loaded"}>
            <table className="tabellaJSON">
                <thead>
                    {this.EsponiIntestazione()}
                    {this.EsponiFiltri()}
                </thead>
                <tbody>
                    {this.EsponiDati()}
                </tbody>
            </table>
            {this.EsponiComandi()}
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/CampoTabellaJSON.tsx